/*-------------------------------------------
	createModal Function
---------------------------------------------*/
export function createModal(title, content) {
	let modalTrigger = document.createElement('button');
	modalTrigger.classList.add('d-none');

	modalTrigger.setAttribute('id', 'btn-call-ajax-modal');
	modalTrigger.setAttribute('type', 'button');
	modalTrigger.setAttribute('data-bs-toggle', 'modal');
	modalTrigger.setAttribute('data-bs-target', '#ajax-modal');

	let modal = document.createElement('div');
	modal.classList.add('modal', 'fade');
	modal.setAttribute('id', 'ajax-modal');
	modal.setAttribute('tabindex', '-1');
	modal.setAttribute('role', 'dialog');
	modal.setAttribute('aria-hidden', 'true');

	let modalWrap = document.createElement('div');
	modalWrap.classList.add('modal-dialog', 'modal-dialog-centered', 'modal-lg');
	modalWrap.setAttribute('role', 'document');

	let modalContent = document.createElement('div');
	modalContent.classList.add('modal-content');

	let modalHeader = document.createElement('div');
	modalHeader.classList.add('modal-header');

	let modalTitle = document.createElement('h5');
	modalTitle.classList.add('modal-title');
	modalTitle.innerHTML = title;

	let button = document.createElement('button');
	button.classList.add('btn-close');
	button.setAttribute('type', 'button');
	button.setAttribute('data-bs-dismiss', 'modal');
	button.setAttribute('aria-label', 'Close');

	let modalBody = document.createElement('div');
	modalBody.classList.add('modal-body');

	modalHeader.appendChild(modalTitle);
	modalHeader.appendChild(button);

	if(content.nodeType == 1) {
		modalBody.appendChild(content);
	} else {
		modalBody.innerHTML = content;
	}

	modalContent.appendChild(modalHeader);
	modalContent.appendChild(modalBody);

	modalWrap.appendChild(modalContent);

	modal.appendChild(modalWrap);

	const parent = document.getElementsByClassName('page');
	parent[0].appendChild(modalTrigger);
	parent[0].appendChild(modal);
	
	simulateClick(document.getElementById('btn-call-ajax-modal'));

	const myModalEl = document.getElementById('ajax-modal')
	myModalEl.addEventListener('hidden.bs.modal', event => {
		const btn = document.getElementById('btn-call-ajax-modal');
		btn.parentNode.removeChild(btn);

		const modal = document.getElementById('ajax-modal');
		modal.parentNode.removeChild(modal);
	});
}

/**
 * Simulate a click event.
 * @public
 * @param {Element} elem  the element to simulate a click on
 */
var simulateClick = function (elem) {
	// Create our event (with options)
	var evt = new MouseEvent('click', {
		bubbles: true,
		cancelable: true,
		view: window
	});

	// If cancelled, don't dispatch our event
	var canceled = !elem.dispatchEvent(evt);
};